module.exports = __webpack_public_path__ + "img/payment-active.0b65d112.svg";